import React from "react";
import Fishbone from 'fishbone-chart'
import { Lesson } from "../../types/Lessons";

const FishboneChart = (lesson: Lesson) => {
  const categories = {};
  lesson.causes.forEach(cause => {
    categories[cause.category.name] ||= [];
    categories[cause.category.name].push(cause.issue);
  });
  const data = {
    [lesson.headline]: categories
  }

  return <Fishbone data={data} />;
};

export default FishboneChart;